// @react/hooks/useTaskTaskPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskTaskPolicyStore } from '@core/stores';

/**
 * React hook for TaskPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskTaskPolicy } from '@react/hooks';
 *
 * const TaskPolicyList = observer(() => {
 *   const store = useTaskTaskPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskTaskPolicy() {
  return taskTaskPolicyStore;
}
